import { IProjectCheckError, IProjectCheckErrorFieldGroup, ProjectCheckErrorPosition, ProjectCheckErrorType } from "./ProjectDefinitions";

export const ProjectCheckErrorHelper = {
  create(position: ProjectCheckErrorPosition, text: string, type: ProjectCheckErrorType, errorUrl?: string): IProjectCheckError {
    return {
      position,
      text,
      type,
      fields: [],
      v: 2,
      errorUrl
    };
  },
  addFields<T>(error: IProjectCheckError, _inputMode: T, group: IProjectCheckErrorFieldGroup, ...fields: (keyof T)[]) {
    for (const f of fields) {
      error.fields.push({ id: f as string, group });
    }
  },
  countErrors(errors: IProjectCheckError[], type: ProjectCheckErrorType, exact?: boolean) {
    errors = upgradeErrors(errors);
    let count = 0;
    for (const e of errors) {
      if (exact ? e.type === type : e.type >= type) count++;
    }
    return count;
  },
  filterErrors(errors: IProjectCheckError[], type: ProjectCheckErrorType, exact?: boolean) {
    errors = upgradeErrors(errors);
    const ret: IProjectCheckError[] = [];
    for (const e of errors) {
      if (exact ? e.type === type : e.type >= type) ret.push(e);
    }
    return ret;
  },
  hasError(errors: IProjectCheckError[], type: ProjectCheckErrorType, exact?: boolean) {
    errors = upgradeErrors(errors);
    for (const e of errors) {
      if (exact ? e.type === type : e.type >= type) return true;
    }
    return false;
  },
  calcMaxError(errors: IProjectCheckError[] | undefined) {
    errors = upgradeErrors(errors);
    let maxError = ProjectCheckErrorType.None;
    if (!errors.length)
      return maxError;

    for (const e of errors) {
      if (e.type > maxError) {
        maxError = e.type;
        if (maxError === ProjectCheckErrorType.FatalError) return maxError;
      }
    }
    return maxError;
  },
};

export function upgradeErrors(errors: IProjectCheckError[] | undefined): IProjectCheckError[] {
  if (!errors)
    return [];
  for (const e of errors) {
    if (!e.v) {
      return errors.map<IProjectCheckError>((e) => ({ ...e, v: 2, type: e.type * 100 }))
    }
  }
  return errors;
}